import { useCallback, useMemo } from 'react';
import MuiTable from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableFooter from './components/TableFooter.component';
import TableHead from './components/TableHead.component';
import TableBody from './components/TableBody.component';
import { Box } from '@mui/material';
import TableToolbar from './components/TableToolbar.component';
import { useScrollPosition } from '../../hooks/useScrollPosition';

const Table = ({
  render,
  rows = [],
  columns = [],
  pagination,
  total = 0,
  rowsPerPageOptions,
  onChangePagination = () => {},
  sort,
  onChangeSort = () => {},
  onClick = () => {},
  onSelectItem = () => {},
  selected,
  toolbar,
  onClickToolbar = () => {},
  onSelectAll = () => {},
  resetSelectAction,
  tag,
  children,
}) => {
  const { ref, saveScrollPosition } = useScrollPosition(tag, [rows]);

  const numSelected = useMemo(
    () => selected && Object.values(selected).flat()?.length,
    [selected]
  );

  const selectedItems = useMemo(
    () => selected?.[pagination?.page],
    [pagination, selected]
  );

  const handleClick = useCallback(
    (item) => {
      saveScrollPosition();
      onClick(item);
    },
    [onClick, saveScrollPosition]
  );

  const handleSelectItem = useCallback(
    (item) => {
      saveScrollPosition();
      onSelectItem(item);
    },
    [onSelectItem, saveScrollPosition]
  );

  const handleSavePosition = useCallback(() => {
    saveScrollPosition();
  }, [saveScrollPosition]);

  return (
    <Box sx={{ width: '100%', overflow: 'hidden' }}>
      <TableToolbar
        numSelected={numSelected}
        toolbar={toolbar}
        onClickToolbar={onClickToolbar}
      >
        {children}
      </TableToolbar>
      <TableContainer sx={{ height: '70vh', overflow: 'auto' }} ref={ref}>
        <MuiTable stickyHeader={true}>
          <TableHead
            formatHead={render.formatHead}
            columns={columns}
            sort={sort}
            onChangeSort={onChangeSort}
            onSelectAll={onSelectAll}
            rows={rows}
            numSelected={selectedItems?.length}
            isChecked={
              rows?.length > 0 && rows?.length === selectedItems?.length
            }
            resetSelectAction={resetSelectAction}
          />
          <TableBody
            formatValue={render.formatValue}
            rows={rows}
            columns={columns}
            onClick={handleClick}
            onSelectItem={handleSelectItem}
            selected={selectedItems}
            handleSavePosition={handleSavePosition}
          />
        </MuiTable>
      </TableContainer>
      <TableFooter
        pagination={pagination}
        total={total}
        rowsPerPageOptions={rowsPerPageOptions}
        onChange={onChangePagination}
        resetSelectAction={resetSelectAction}
        numSelected={numSelected}
      />
    </Box>
  );
};

export default Table;
